import { signal } from '@angular/core';
import {EntryMapper} from '../../../entry/infrastructure/mapper/entry.mapper';
import {PaymentMapper} from '../../../payment/domain/mappers/payment.mapper';
import {Account} from '../../domain/model/account.model';
import {IAccount} from '../interfaces/account-storage.interface';
import {AccountStorageMapper} from './account-storage.mapper';

export class AccountEntityMapper {
  static fromStorage(data: IAccount): Account {
    return new Account(
      data._id,
      data.negocio_id,
      data.closed,
      data.waiter_id,
      data.device_id,
      data.cash_drawer_id,
      signal<number>(data.products_quantity),
      data.total,
      data.service_id,
      data.location_id,
      EntryMapper.mapToEntryMap(data.entries),
      data.trackId,
      data.payments_ids,
      data.refund_ids,
      PaymentMapper.mapToPaymentMap(data.payments ?? []),
      data.zona_id,
      data.created_at,
      data.created_by,
      data.updated_at,
      data.removed_at,
      data.closed_at,
      data.note,
      data.name,
      data.formatedDate,
      data.formatedHour,
      data.closedFormatedHour,
      data.ticket_id,
      data.serie,
      data.ticketNumber,
      data.ticketSerie,
      data.ticketPrefix,
      data.totalPaid,
      data.totalRemaining,
      data.priceCurrency,
      data.color,
      data.location,
      data.drawer,
      data.waiter,
      data.serverUpdatedAt,
      data.actualUpdatedAt,
      data.booking_id,
      data.isLocked,
    );
  }

  static deepClone(account: Account): Account {
    return AccountEntityMapper.fromStorage(
      AccountStorageMapper.fromEntity(account)
    );
  }
}
